import moment from "moment";
import axios from "axios";
import { URL } from '../../env';
import _ from 'lodash'
export default {
    data: () => ({
        deal: {},
        company: {},
        bankAccounts: [],
        bankStatements: [],
        companyMerchants: [],
        company_address: [],
        dealFiles: [],
        company_mca: [],
        deal_lenders: [],
        google_api: "https://www.google.com/maps/embed/v1/place?key=AIzaSyB2hswXGGWmKR5LrMtr9OWVKt-MlZBPO68&q="
    }),
    computed: {
        timeBusiness() {
            let diff = 0;
            let time_in_biz = moment(this.company.company_started_date, "MMYYYY");
            diff = moment().diff(time_in_biz, "years", true);
            return Number(diff.toFixed(1));
        },
        companyAddress() {
            let result = { main: {}, mailing: {} };
            this.company_address.forEach(address => {
                if (address.company_address_type === "Mailing") {
                    result.mailing = {
                        id: address.id,
                        company_street: address.company_street,
                        company_city: address.company_city,
                        company_state: address.company_state,
                        company_zip: address.company_zip,
                        company_id: address.company_id
                    };
                }
                if (address.company_address_type === "Main") {
                    result.main = {
                        id: address.id,
                        company_street: address.company_street,
                        company_city: address.company_city,
                        company_state: address.company_state,
                        company_zip: address.company_zip,
                        company_id: address.company_id
                    };
                }
            });

            return result.main;
        },
        dealLenderOffer() {
            let result = {};
            if (this.deal_lenders.length > 0) {
                result = this.deal_lenders.filter(lender => lender.lender_offer_status === "Offer Accepted");
                if (result.length > 0) {
                    return result[0];
                }
                return {};
            }

            return result;
        },
        dealLenders() {
            return _.filter(this.deal_lenders, o => o.lender_offer_status == 'Offer Accepted')
        },
        fcsCompanyRow() {
            let uniq = _.uniqBy(this.dealFiles, 'month_name');
            let arr = []
            uniq.forEach(o => {
                if (_.filter(this.dealFiles, x => x.calculate_row != 0 && x.month_name == o.month_name).length != 0) {
                    arr.push({
                        month_name: o.month_name,
                        month_deposit_amount: _.sumBy(this.dealFiles, function (res) { return (res.calculate_row != 0 && res.month_name == o.month_name) ? parseFloat(res.month_deposit_amount) : 0 }),
                        month_transfer_amount: _.sumBy(this.dealFiles, function (res) { return (res.calculate_row != 0 && res.month_name == o.month_name) ? parseFloat(res.month_transfer_amount) : 0 }),
                        month_other_advances: _.sumBy(this.dealFiles, function (res) { return (res.calculate_row != 0 && res.month_name == o.month_name) ? parseFloat(res.month_other_advances) : 0 }),
                        month_deduction: _.sumBy(this.dealFiles, function (res) { return (res.calculate_row != 0 && res.month_name == o.month_name) ? parseFloat(res.month_deduction) : 0 }),
                        month_net_deposits: _.sumBy(this.dealFiles, function (res) { return (res.calculate_row != 0 && res.month_name == o.month_name) ? parseFloat(res.month_net_deposits) : 0 }),
                        month_number_of_deposits: _.sumBy(this.dealFiles, function (res) { return (res.calculate_row != 0 && res.month_name == o.month_name) ? parseFloat(res.month_number_of_deposits) : 0 }),
                        month_negative_days: _.sumBy(this.dealFiles, function (res) { return (res.calculate_row != 0 && res.month_name == o.month_name) ? parseFloat(res.month_negative_days) : 0 }),
                        month_average_balance: _.sumBy(this.dealFiles, function (res) { return (res.calculate_row != 0 && res.month_name == o.month_name) ? parseFloat(res.month_average_balance) : 0 }),
                        month_monthly_beginning_balance: _.sumBy(this.dealFiles, function (res) { return (res.calculate_row != 0 && res.month_name == o.month_name) ? parseFloat(res.month_monthly_beginning_balance) : 0 }),
                        month_monthly_ending_balance: _.sumBy(this.dealFiles, function (res) { return (res.calculate_row != 0 && res.month_name == o.month_name) ? parseFloat(res.month_monthly_ending_balance) : 0 })
                    })
                }
            });
            return arr
        },
        caculateTotalAverageForAgg() {
            let daily_balance = 0;
            let deposit_amount = 0;
            let month_deduction = 0;
            let month_monthly_beginning_balance = 0;
            let month_monthly_ending_balance = 0;
            let negative_days = 0;
            let net_deposit = 0;
            let number_deposit = 0;
            let other_advance = 0;
            let trans_amount = 0
            let mca_withhold = 0

            if (this.fcsCompanyRow.length == 0) {
                return {
                    daily_balance: 0,
                    deposit_amount: 0,
                    month_deduction: 0,
                    month_monthly_beginning_balance: 0,
                    month_monthly_ending_balance: 0,
                    negative_days: 0,
                    net_deposit: 0,
                    number_deposit: 0,
                    other_advance: 0,
                    trans_amount: 0,
                    mca_withhold: 0
                }
            }

            deposit_amount = _.sumBy(this.fcsCompanyRow, function (res) { return (res.calculate_row != 0) ? parseFloat(res.month_deposit_amount) : 0 }) / this.fcsCompanyRow.length
            trans_amount = _.sumBy(this.fcsCompanyRow, function (res) { return (res.calculate_row != 0) ? parseFloat(res.month_transfer_amount) : 0 }) / this.fcsCompanyRow.length
            other_advance = _.sumBy(this.fcsCompanyRow, function (res) { return (res.calculate_row != 0) ? parseFloat(res.month_other_advances) : 0 }) / this.fcsCompanyRow.length
            month_deduction = _.sumBy(this.fcsCompanyRow, function (res) { return (res.calculate_row != 0) ? parseFloat(res.month_deduction) : 0 }) / this.fcsCompanyRow.length
            net_deposit = _.sumBy(this.fcsCompanyRow, function (res) { return (res.calculate_row != 0) ? parseFloat(res.month_net_deposits) : 0 }) / this.fcsCompanyRow.length
            number_deposit = _.sumBy(this.fcsCompanyRow, function (res) { return (res.calculate_row != 0) ? parseFloat(res.month_number_of_deposits) : 0 }) / this.fcsCompanyRow.length
            negative_days = _.sumBy(this.fcsCompanyRow, function (res) { return (res.calculate_row != 0) ? parseFloat(res.month_negative_days) : 0 }) / this.fcsCompanyRow.length
            daily_balance = _.sumBy(this.fcsCompanyRow, function (res) { return (res.calculate_row != 0 && !isNaN(res.month_average_balance)) ? parseFloat(res.month_average_balance) : 0 }) / this.fcsCompanyRow.length
            month_monthly_beginning_balance = _.sumBy(this.fcsCompanyRow, function (res) { return (res.calculate_row != 0 && !isNaN(res.month_monthly_beginning_balance)) ? parseFloat(res.month_monthly_beginning_balance) : 0 }) / this.fcsCompanyRow.length
            month_monthly_ending_balance = _.sumBy(this.fcsCompanyRow, function (res) { return (res.calculate_row != 0 && !isNaN(res.month_monthly_ending_balance)) ? parseFloat(res.month_monthly_ending_balance) : 0 }) / this.fcsCompanyRow.length

            mca_withhold = 0
            if (this.dealLenderOffer.lender_payment_type == "Weekly" && net_deposit != 0)
                mca_withhold = ((((parseFloat(this.dealLenderOffer.lender_payment) / 5) * 21) / net_deposit) * 100).toFixed(2)
            else if (net_deposit != 0)
                mca_withhold = (((parseFloat(this.dealLenderOffer.lender_payment) * 21) / net_deposit) * 100).toFixed(2)
            else
                mca_withhold

            // this.$emit('sendAvgNetDeposit', net_deposit) // sending avg number_deposit to it's parent FileControlSheetNew.vue and then MCA Information & Advantage MCA Information table
            return {
                daily_balance: daily_balance.toFixed(2),
                deposit_amount: deposit_amount.toFixed(2),
                month_deduction: month_deduction.toFixed(2),
                month_monthly_beginning_balance: month_monthly_beginning_balance.toFixed(2),
                month_monthly_ending_balance: month_monthly_ending_balance.toFixed(2),
                negative_days: negative_days.toFixed(2),
                net_deposit: net_deposit.toFixed(2),
                number_deposit: number_deposit.toFixed(2),
                other_advance: other_advance.toFixed(2),
                trans_amount: trans_amount.toFixed(2),
                mca_withhold: mca_withhold
            }
        },
        fcsRow() {
            let len = this.bankAccounts.length;
            var data = [];
            for (var i = 0; i < len; i++) {
                var item = {
                    account_id: this.bankAccounts[i].id,
                    data: this.bankStatements.filter(x => x.bank_account_id == this.bankAccounts[i].id)
                }
                data.push(item)
            }
            return data;
        },
        mcaRows() {
            let data = this.company_mca
            data.forEach(o => {
                if (o.payment_type == null || o.payment_type == 'Daily') {
                    return Object.assign(o, {
                        with_hold: (this.caculateTotalAverageForAgg.net_deposit != 0) ? (((o.mca_daily_payment * 21) / this.caculateTotalAverageForAgg.net_deposit) * 100).toFixed(2) : 0
                    })
                } else {
                    return Object.assign(o, {
                        with_hold: (this.caculateTotalAverageForAgg.net_deposit != 0) ? (((o.mca_weekly_payment * 4) / this.caculateTotalAverageForAgg.net_deposit) * 100).toFixed(2) : 0
                    })
                }
            });
            return data
        },
        caculateTotalSum() {
            return {
                mca_daily_payment: _.sumBy(this.mcaRows, function (res) {
                    if(!(res.status=='paying off' || res.status == 'paid off') && res.mca_daily_payment)
                      return parseFloat(res.mca_daily_payment)
                    else
                      return 0
                }),
                mca_weekly_payment: _.sumBy(this.mcaRows, function (res) {
                    if(!(res.status=='paying off' || res.status == 'paid off') && res.mca_weekly_payment)
                        return parseFloat(res.mca_weekly_payment)
                    else
                        return 0
                }),
                mca_balance: _.sumBy(this.mcaRows, function (res) { 
                    if(!(res.status=='paying off' || res.status == 'paid off') && res.mca_balance)
                        return parseFloat(res.mca_balance)
                    else
                        return 0
                }),
                mca_original_funding_amount: _.sumBy(this.mcaRows, function (res) { 
                    if(!(res.status=='paying off' || res.status == 'paid off') && res.mca_original_funding_amount)
                        return parseFloat(res.mca_original_funding_amount)
                    else
                        return 0
                }),
                total_with_hold: _.sumBy(this.mcaRows, function (res) {
                    if(!(res.status=='paying off' || res.status == 'paid off') && res.with_hold)
                        return parseFloat(res.with_hold)
                    else
                        return 0
                }),
            }
        },
    },
    created() {
        this.get();
    },

    methods: {
        async get() {
            await this.getDeal()
            await this.getCompany();
            await this.getCompanyAddress();
            await this.gettingFCSCalc();
            await this.dealOffer()
            await this.getCompanyBankAccount()
            await this.getCompanyBankStm()
            await this.getCompanyMCA()
            await this.getCompanyMerchants()
        },
        async getDeal(){
            return await axios.get(`${URL}/api/get_deal_data/` + this.$route.params.unique_id)
                .then(res => {
                    this.deal = res.data.length>0 ? res.data[0] : {}
                });
        },
        async getCompanyMerchants(){
            return await axios.get(`${URL}/api/company_merchant/merchant_for_company/` + this.company.id)
                .then(res => {
                    this.companyMerchants = res.data.data
                });
        },
        async getCompanyMCA() {
            return await axios.get(`${URL}/api/mcainformation/mcas/` + this.company.id)
                .then(res => {
                    this.company_mca = res.data.data
                });
        },
        async gettingFCSCalc() {
            return await axios.get(`${URL}/api/filecontrolsheet/getFCSRowsCompanyCalc/` + this.company.id)
                .then(res => {
                    this.dealFiles = res.data.data
                });
        },
        async dealOffer() {
            return await axios.get(`${URL}/api/deal_lender/deal_lenders_synd/` + this.deal.contract_MID)
                .then(res => {
                    this.deal_lenders = res.data.data
                });
        },
        async getCompanyBankAccount() {
            return await axios.get(`${URL}/api/company/getCompanyBankAccount/` + this.company.id)
                .then(res => {
                    this.bankAccounts = res.data
                });
        },
        async getCompanyBankStm() {
            return await axios.get(`${URL}/api/company/getCompanyBankStm/` + this.company.id)
                .then(res => {
                    this.bankStatements = _.filter(res.data, o=> o.calculate_row)
                });
        },
        async getCompany() {
            return await axios.get(`${URL}/api/company/get_company/` + this.deal.contract_MID)
                .then(res => {
                    this.company = res.data.length > 0 ? res.data[0] : {};
                });
        },
        async getCompanyAddress() {
            return await axios
                .get(`${URL}/api/company_address/company_addresses/` + this.company.id)
                .then(res => {
                    this.company_address = res.data.data;
                });
        },
        getgooglemap: function (
            company_street,
            company_city,
            company_state,
            company_zip
        ) {
            return (
                this.google_api +
                company_street +
                company_city +
                company_state +
                company_zip
            );
        },
        formatPrice(value) {
            if (Number.isNaN(value)) {
                return 0.0;
            }
            let val = (value / 1).toFixed(2).replace(",", ".");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        caculateWithholdAverage(lender_payment, lender_payment_type) {
            let cal = 0
            if (lender_payment_type == "Weekly" && this.caculateTotalAverageForAgg.net_deposit != 0)
                cal = ((((parseFloat(lender_payment) / 5) * 21) / this.caculateTotalAverageForAgg.net_deposit) * 100).toFixed(2)
            else if (this.caculateTotalAverageForAgg.net_deposit != 0)
                cal = (((parseFloat(lender_payment) * 21) / this.caculateTotalAverageForAgg.net_deposit) * 100).toFixed(2)
            else
                cal
            return cal
        }
    }
};